import { useContext } from "react";
import cls from "skin/entry/tool/cls";
import styles from './style.module.css';
import DropCtx from "../context";
import Icon from "../../icon";
import fieldStyles from '../../field/base/style.module.css';

/**
 * Всегда видимое поле, при нажатии на которое - открывается выпадающий список.
 * @param {string} placeholder - вместо children, если того нет
 * @param {any} label - надпись над полем
 * @param {any} children - содержимое поля
 * @returns 
 */
export default function Trigger({ err, type='layer0', disabled, placeholder='Выберите значение из списка', label, children }) {
	const { open, setOpen } = useContext(DropCtx);
	const [content, ...clsName] = children
		? [children, styles.input]
		: [placeholder, styles.input, styles.placeholder];
	const onClick = ev => {
		setOpen(v => !v);
		ev.stopPropagation();
	};
	return <div className={styles.body}>
		<h4>{label}</h4>
		<div className={cls(styles.fieldset, fieldStyles[type], disabled ? styles.disabled : null, open && styles.open, err && fieldStyles.errBox).join()} onClick={disabled ? () => { } : onClick}>
			<div className={cls(...clsName).join()}>{content}</div>
			<Img {...{disabled, open}} />
		</div>
		{(err && typeof err === 'string') ? <span className={fieldStyles.err}>{err}</span> : null}
	</div>
}

function Img({ disabled, open }) {
	if (disabled) return null;
	const [clr, rot] = open ? ['var(--text)', 'up'] : ['var(--placeholder)', 'down'];
	return <Icon name='arrow' color={clr} rotate={rot} />;
}